<template>
  <a-modal
    :title="'审核'"
    okText="确定"
    @ok="save"
    v-model="visible"
    :width="450"
    wrapClassName="recommend-modal"
  >
    <a-form :form="form">
      <h3 :style="{ marginTop: '20px' }">请填写审核不通过的原因：</h3>
      <a-form-item>
        <a-textarea
          placeholder="请填写审核不通过的原因"
          :rows="4"
          v-decorator="[
            'reason',
            { rules: [{ required: true, message: '请填写审核不通过的原因' }] }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "EditMessage",
  props: {
    callback: {
      type: Function
    }
  },
  created() {},
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      company: ""
    };
  },
  watch: {},
  methods: {
    save() {
      console.log("添加");
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            company_id: this.company.id,
            remark: values.reason
          };
          console.log(params);
          Api.client.reviewUnPass(params).then(res => {
            console.log(res);
            if (res) {
              this.$message.success("添加成功");
              this.callback && this.callback();
              this.visible = false;
            } else {
              this.$message.error("添加失败");
            }
          });
        }
      });
    },

    show(item) {
      this.visible = true;
      console.log(item);
      this.company = item;
      this.$nextTick().then(() => {
        // this.form.setFieldsValue({
        //   company : this.record.name,
        // });
      });
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss"></style>
